import { LocalStorageUtils } from "@assetmark/ui-kit/dist/utils/local-storage.utils";
import { LEAD_APP_STATE } from "../constants/storage.constant";
import { TInvestorNavState } from "../contexts/lead/lead.model";
import { LeadStrategyInfoResponse } from "../lib/das-api/model/leadStrategyInfoResponse";
import { LeadCategory } from "../models/lead-category-enum";

export const getRedirectPage = (lastVisitedPage: string, goalType = "") => {
    if(lastVisitedPage.toLowerCase() === 'about') {
        return 'investment_amount';
    }

    if(lastVisitedPage.toLowerCase() === 'investment_amount') {
        return 'investment_reason';
    }

    if(lastVisitedPage.toLowerCase() === 'investment_reason') {
        if(goalType === '3') {
            return 'goals/investment_target';
        } else if(goalType === '2') {
            return 'goals/retirement_age';
        } else {
            return 'risk-profile/investment_return';
        }
    }

    if(lastVisitedPage.toLowerCase() === 'retirement_age') {
        return 'goals/monthly_income';
    }

    if(lastVisitedPage.toLowerCase() === 'monthly_income') {
        return 'goals/retirement_income';
    }

    if(lastVisitedPage.toLowerCase() === 'retirement_income') {
        return 'goals/annual_contribution';
    }

    if(lastVisitedPage.toLowerCase() === 'annual_contribution') {
        return 'risk-profile/investment_return';
    }

    if(lastVisitedPage.toLowerCase() === 'investment_target') {
        return 'risk-profile/investment_return';
    }

    if(lastVisitedPage.toLowerCase() === 'investment_return') {
        return 'risk-profile/maximum_decline';
    }

    if(lastVisitedPage.toLowerCase() === 'maximum_decline') {
        return 'risk-profile/stock_market';
    }

    if(lastVisitedPage.toLowerCase() === 'stock_market') {
        return 'risk-profile/age_range';
    }

    if(lastVisitedPage.toLowerCase() === 'age_range') {
        return 'risk-profile/planned_withdrawal';
    }
    if(lastVisitedPage.toLowerCase() === 'planned_withdrawal') {
        return 'risk-profile/risk_result'; // once wb-78 complete then will give it to route
    }

    if(lastVisitedPage.toLowerCase() === 'your-analysis') {
        return 'planned_withdrawal'; // need to think where to send
    }

    return 'about';
};

export const getLastVisitedPageCategory = (investorNavState: TInvestorNavState): string => {
        const { aboutYouVisited, goalsVisited, riskVisited, analysisVisited } = investorNavState;
        
    if(aboutYouVisited && goalsVisited && riskVisited && analysisVisited) {
        return LeadCategory.YourAnalysis;
    } else if(aboutYouVisited && goalsVisited && riskVisited) {
        return LeadCategory.RiskProfile;
    } else if(aboutYouVisited && goalsVisited) {
        return LeadCategory.SetGoal;
    } else if(aboutYouVisited) {
        return LeadCategory.ClientProfile;
    } else {
        return LeadCategory.ClientProfile;
    }
};

export const getLastVisitedPage = (toBoLastPage: string) => {
    const numeriLeadCategory = {
		[LeadCategory.ClientProfile.toString().toLowerCase()]: 1,
		[LeadCategory.SetGoal.toString().toLowerCase()]: 2,
		[LeadCategory.RiskProfile.toString().toLowerCase()]: 3,
		[LeadCategory.YourAnalysis.toString().toLowerCase()]: 4,
	};

    const numCurrentPage = numeriLeadCategory[toBoLastPage.toLowerCase()];

    const leadState = LocalStorageUtils.getItem<LeadStrategyInfoResponse>(LEAD_APP_STATE);
	
	if (leadState.isSome()) {
		const lead = leadState.getOrElse({});
		const numLastPage = lead.lastPageVisited ? numeriLeadCategory[lead.lastPageVisited.toLowerCase()] : 1;
        if (numCurrentPage === numLastPage) {
            return toBoLastPage;
        } else if (numCurrentPage < numLastPage) {
            return lead.lastPageVisited || "";
        } else {
            return toBoLastPage;
        }   
	} else {
        return toBoLastPage;
    }
};